// 상대경로 이미지는 API_BASE를 붙여서 절대 URL로 변환
const API_BASE = (import.meta.env.VITE_API_BASE ?? "").replace(/\/+$/, "");

export const toCoverUrl = (url?: string): string => {
    if (!url) return "";
    const trimmed = url.trim();
    // 상대경로 (/uploads/...)는 API_BASE를 붙임
    if (trimmed.startsWith("/")) return `${API_BASE}${trimmed}`;
    return trimmed;
};
